import { gql, useQuery } from '@apollo/client';

const useGetRegisteredPaymentMethodsUser = ({ variables, skip }) => {
  const { data, error, loading, refetch } = useQuery(
    gql`
      query($id: String!) {
        user(id: $id) {
          registeredPaymentMethods {
            id
            kind
            ... on CardPaymentMethod {
              cardInfo {
                last4
                brand
                expYear
                expMonth
                fingerPrint
                __typename
              }
              __typename
            }
            ... on BankDebitPaymentMethod {
              id
              kind
              validationStatus
              bankName
              last4
              __typename
            }
            # ... on BankCreditPaymentMethod {
            #   status
            #   sourceInfo {
            #     bankName
            #     accountNumber
            #     swiftCode
            #     routingNumber
            #     __typename
            #   }
            #   __typename
            # }
            ... on ManualPaymentMethod {
              manualPaymentInfo {
                bankName
                accountNumber
                routingNumber
                beneficiary
                address
                swiftCode
                __typename
              }
              __typename
            }
            ... on ZellePaymentMethod {
              kind
              zellePaymentInfo {
                emailToSend
                __typename
              }
              __typename
            }
            __typename
          }
        }
      }
    `,
    {
      variables,
      skip
    }
  );

  return { loading, data: data?.user || [], error, refetch };
};

export default useGetRegisteredPaymentMethodsUser;
